import React, { useEffect, useState } from 'react';
import { X, Loader2, Check, PhoneCall } from 'lucide-react';
import { api } from '../context/AuthContext';

export const ERGEBNISSE = [['erreicht', 'Erreicht – besprochen'], ['termin', 'Termin vereinbart'], ['nicht_erreicht', 'Nicht erreicht'],
  ['mailbox', 'Mailbox / Nachricht hinterlassen'], ['meldet_sich', 'Mandant meldet sich'], ['erledigt_sonst', 'Sonstiges']];
export const ergebnisLabel = (k) => (ERGEBNISSE.find(([key]) => key === k) || [null, k])[1];

export const GespraechNotiz = ({ r, onEdit }) => (r.status === 'erledigt' && (r.ergebnis || r.notiz) ? (
  <div className="mt-2 px-3 py-2 bg-[#fbf7f0] border-l-2 border-[#b8893d] text-xs" data-testid={`rueckruf-gespraech-${r.rueckruf_id}`}>
    <div className="flex items-center gap-2 text-[10px] tracking-wider uppercase text-[#b8893d]">
      <PhoneCall className="w-3 h-3" /> {ergebnisLabel(r.ergebnis) || 'Gespräch'}{r.erledigt_von?.name ? ` · ${r.erledigt_von.name}` : ''}
      {onEdit && <button type="button" onClick={onEdit} className="ml-auto normal-case tracking-normal text-[#1B3A5C] underline hover:text-[#b8893d]" data-testid={`rueckruf-notiz-edit-${r.rueckruf_id}`}>Bearbeiten</button>}
    </div>
    {r.notiz && <p className="mt-1 text-[#34536b] whitespace-pre-line">{r.notiz}</p>}
  </div>
) : null);

export const ErledigenDialog = ({ r, onClose, onDone }) => {
  const edit = r.status === 'erledigt';
  const mnr = r.zuordnung?.mandanten_nr;
  const [ergebnis, setErgebnis] = useState(r.ergebnis || '');
  const [notiz, setNotiz] = useState(r.notiz || '');
  const [caseId, setCaseId] = useState(r.zuordnung?.case_id || '');
  const [akten, setAkten] = useState([]);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  useEffect(() => {
    if (!mnr || edit) return;
    api.get('/cases/neuer-chat/suche', { params: { q: mnr } }).then((x) => setAkten((x.data.items || []).find((m) => m.mandanten_nr === mnr)?.akten || [])).catch(() => {});
  }, [mnr, edit]);

  const save = async () => {
    setBusy(true); setErr('');
    try {
      if (edit) await api.patch(`/team/rueckrufe/${r.rueckruf_id}/gespraech`, { ergebnis, notiz });
      else await api.post(`/team/rueckrufe/${r.rueckruf_id}/erledigen`, { ergebnis, notiz, case_id: caseId || undefined });
      onDone();
    } catch (e) { setErr(e?.response?.data?.detail || 'Speichern fehlgeschlagen'); }
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-[60] bg-black/40 flex items-center justify-center p-4" onClick={onClose} data-testid="rueckruf-erledigen-dialog">
      <div className="bg-white w-full max-w-md shadow-xl" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-5 py-3 border-b border-gray-100">
          <span className="text-sm font-semibold text-[#1B3A5C]">{edit ? 'Gesprächsnotiz bearbeiten' : 'Rückruf erledigen'} · {r.name}</span>
          <button type="button" onClick={onClose} aria-label="Schließen" data-testid="rueckruf-erledigen-close"><X className="w-4 h-4 text-[#7a8a99]" /></button>
        </div>
        <div className="p-5 space-y-3">
          <div>
            <p className="mb-1.5 text-[10px] tracking-[0.15em] uppercase text-[#7a8a99]">Ergebnis *</p>
            <div className="flex flex-wrap gap-1.5">
              {ERGEBNISSE.map(([k, l]) => (
                <button key={k} type="button" onClick={() => setErgebnis(k)} data-testid={`rueckruf-ergebnis-${k}`}
                  className={`px-3 py-1.5 text-[11px] rounded-full border transition-colors ${ergebnis === k ? 'bg-[#1B3A5C] border-[#1B3A5C] text-white' : 'bg-white border-gray-200 text-[#1B3A5C] hover:border-[#b8893d]'}`}>{l}</button>
              ))}
            </div>
          </div>
          <label className="block">
            <span className="block mb-1 text-[10px] tracking-[0.15em] uppercase text-[#7a8a99]">Gesprächsnotiz (optional)</span>
            <textarea rows={5} value={notiz} onChange={(e) => setNotiz(e.target.value)} placeholder="Was wurde besprochen? Nächste Schritte …" data-testid="rueckruf-notiz-input"
              className="w-full border border-gray-200 px-3 py-2 text-sm text-[#1B3A5C] focus:outline-none focus:border-[#b8893d]" />
          </label>
          {!edit && akten.length > 0 && (
            <label className="block">
              <span className="block mb-1 text-[10px] tracking-[0.15em] uppercase text-[#7a8a99]">Akte (optional)</span>
              <select value={caseId} onChange={(e) => setCaseId(e.target.value)} data-testid="rueckruf-erledigen-akte" className="w-full border border-gray-200 px-3 py-2 text-sm text-[#1B3A5C] focus:outline-none focus:border-[#b8893d]">
                <option value="">Ohne Akte (Allgemein)</option>
                {akten.map((a) => <option key={a.id} value={a.id}>{a.aktenzeichen ? `AZ ${a.aktenzeichen}` : a.rechtsgebiet}</option>)}
              </select>
            </label>
          )}
          {!mnr && !edit && <p className="text-[11px] text-[#7a8a99]">Hinweis: Dieser Rückruf ist keinem Mandanten zugeordnet und erscheint daher in keinem Zeitstrahl.</p>}
          {err && <p className="px-2 py-1 text-xs text-red-700 bg-red-50" data-testid="rueckruf-erledigen-error">{err}</p>}
        </div>
        <div className="flex justify-end px-5 py-3 border-t border-gray-100">
          <button type="button" onClick={save} disabled={busy || !ergebnis} data-testid="rueckruf-erledigen-speichern"
            className="inline-flex items-center gap-1.5 px-4 py-2 text-[11px] tracking-wider bg-[#1B3A5C] text-white hover:bg-[#b8893d] transition-colors disabled:opacity-40">
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Check className="w-3.5 h-3.5" />} {edit ? 'SPEICHERN' : 'ALS ERLEDIGT SPEICHERN'}
          </button>
        </div>
      </div>
    </div>
  );
};
